export function openWhatsapp(

    mobile,

    message = ""

){

    if(!mobile){

        return;
    }

    const phone = String(mobile)
        .replace(/\D/g,"");

    const text = encodeURIComponent(message);

    window.open(

        `https://wa.me/91${phone}?text=${text}`,

        "_blank"

    );

}